module.exports = __webpack_public_path__ + "img/bmw-usa-tablet_b78192bc3c6b891b85b5ececb66a14bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/bmw-usa-tablet.jpg
// module id = 291
// module chunks = 0